// Bundled stylesheet for the ecommerce Smart Doc renderers. Injected
// once on first mount via injectEcomStyles(). Class names mirror the
// Angular component selectors so the React port renders identically.

let injected = false

export function injectEcomStyles(): void {
  if (injected) return
  if (typeof document === 'undefined') return
  injected = true
  const el = document.createElement('style')
  el.setAttribute('data-ecom-blocks', '')
  el.textContent = ECOM_CSS
  document.head.appendChild(el)
}

const ECOM_CSS = `
/* ── customer-picker ────────────────────────────── */
.cp { display:flex; flex-direction:column; gap:12px; padding:16px;
  background:var(--pg-surface,#fff); border:1px solid var(--pg-border,rgba(0,0,0,0.08));
  border-radius:var(--pg-radius,10px); }
.cp--compact { padding:12px; gap:8px; }
.cp__bar { display:flex; align-items:center; gap:8px; }
.cp__icon { font-size:16px; opacity:0.7; }
.cp__input { flex:1; padding:10px 12px; font-size:0.95rem;
  background:var(--pg-bg,#fafafa); border:1px solid var(--pg-border,rgba(0,0,0,0.12));
  border-radius:8px; color:var(--pg-text,#1a1a1a); outline:none; font-family:inherit; }
.cp__input:focus { border-color:var(--pg-primary,#0070f3); }
.cp__newbtn { padding:9px 14px; font-size:0.85rem; font-weight:600;
  background:transparent; color:var(--pg-primary,#0070f3);
  border:1px solid var(--pg-primary,#0070f3); border-radius:8px;
  cursor:pointer; white-space:nowrap; font-family:inherit; }
.cp__newbtn:hover { background:rgba(0,112,243,0.08); }
.cp__list { list-style:none; margin:0; padding:0; display:flex; flex-direction:column;
  gap:4px; max-height:360px; overflow-y:auto; }
.cp__row { display:flex; align-items:center; gap:12px; padding:10px 12px;
  border-radius:8px; cursor:pointer; transition:background 0.12s ease; }
.cp__row:hover { background:var(--pg-surface-alt,rgba(0,0,0,0.03)); }
.cp__row-meta { flex:1; min-width:0; display:flex; flex-direction:column; gap:2px; }
.cp__avatar { width:40px; height:40px; border-radius:50%;
  background:var(--pg-primary,#0070f3); color:var(--pg-on-primary,#fff);
  display:flex; align-items:center; justify-content:center;
  font-weight:600; font-size:0.85rem; flex-shrink:0; }
.cp__avatar--sm { width:32px; height:32px; font-size:0.75rem; }
.cp__name { font-weight:600; font-size:0.92rem; color:var(--pg-text); }
.cp__sub { font-size:0.82rem; color:var(--pg-text-secondary,var(--pg-muted,#666)); }
.cp__chip { font-size:11px; font-weight:600; padding:3px 9px; border-radius:999px; white-space:nowrap; }
.cp__chip--returning { background:var(--pg-success-bg,rgba(34,197,94,0.12)); color:var(--pg-success,#16a34a); }
.cp__chip--new { background:var(--pg-info-bg,rgba(59,130,246,0.12)); color:var(--pg-info,#2563eb); }
.cp__selected { display:flex; align-items:center; gap:12px; padding:12px;
  background:var(--pg-surface-alt,rgba(0,0,0,0.03)); border-radius:8px; }
.cp__selected-meta { flex:1; min-width:0; display:flex; flex-direction:column; gap:4px; }
.cp__change { padding:6px 12px; font-size:0.8rem;
  background:transparent; color:var(--pg-primary,#0070f3);
  border:1px solid transparent; border-radius:6px; cursor:pointer; font-family:inherit; }
.cp__change:hover { background:rgba(0,112,243,0.08); }
.cp__hint, .cp__error { font-size:0.85rem; color:var(--pg-text-secondary,#666); padding:6px 4px; }
.cp__error { color:var(--pg-error,#dc2626); }
.cp__inline { background:transparent; border:none; padding:0; margin-left:6px;
  color:var(--pg-primary,#0070f3); cursor:pointer; font:inherit; }

/* ── new-customer-form ─────────────────────────────── */
.ncf { display:flex; flex-direction:column; gap:14px; padding:18px;
  background:var(--pg-surface,#fff); border:1px solid var(--pg-border,rgba(0,0,0,0.08));
  border-radius:var(--pg-radius,10px); }
.ncf__head { display:flex; align-items:center; justify-content:space-between; }
.ncf__title { margin:0; font-size:1rem; font-weight:700;
  color:var(--pg-heading,var(--pg-text)); }
.ncf__close { background:transparent; border:none; cursor:pointer;
  width:32px; height:32px; border-radius:50%;
  font-size:22px; line-height:1; color:var(--pg-text-secondary); }
.ncf__close:hover { background:var(--pg-surface-alt,rgba(0,0,0,0.04)); }
.ncf__grid { display:grid; grid-template-columns:1fr; gap:12px; }
.ncf__grid--two { grid-template-columns:1fr 1fr; }
.ncf__field { display:flex; flex-direction:column; gap:5px; min-width:0; }
.ncf__field--full { grid-column:1 / -1; }
.ncf__label { font-size:0.78rem; font-weight:600; color:var(--pg-text-secondary);
  text-transform:uppercase; letter-spacing:0.04em; }
.ncf__req { color:var(--pg-error,#dc2626); margin-left:2px; }
.ncf__input { padding:9px 11px; font-size:0.92rem;
  background:var(--pg-bg,#fafafa); border:1px solid var(--pg-border,rgba(0,0,0,0.12));
  border-radius:7px; color:var(--pg-text); outline:none; font-family:inherit; }
.ncf__input:focus { border-color:var(--pg-primary,#0070f3); }
.ncf__textarea { resize:vertical; min-height:70px; }
.ncf__fielderr { font-size:11px; color:var(--pg-error,#dc2626); }
.ncf__error { font-size:0.85rem; color:var(--pg-error,#dc2626);
  padding:8px 10px; border-radius:6px; background:var(--pg-error-bg,rgba(239,68,68,0.08)); }
.ncf__error--full { grid-column:1 / -1; }
.ncf__hint { font-size:0.85rem; color:var(--pg-text-secondary); }
.ncf__actions { grid-column:1 / -1; display:flex; justify-content:flex-end; gap:8px; margin-top:4px; }
.ncf__btn { padding:9px 16px; font-size:0.88rem; font-weight:600;
  border-radius:7px; cursor:pointer; border:1px solid transparent; font-family:inherit; }
.ncf__btn[disabled] { opacity:0.55; cursor:progress; }
.ncf__btn--ghost { background:transparent; color:var(--pg-text); border-color:var(--pg-border); }
.ncf__btn--primary { background:var(--pg-primary,#0070f3); color:var(--pg-on-primary,#fff); }
.ncf__btn--primary:hover:not([disabled]) { filter:brightness(1.05); }

/* ── order-summary ──────────────────────────────────── */
.os { display:flex; flex-direction:column; gap:12px; padding:16px 18px;
  background:var(--pg-surface,#fff); border:1px solid var(--pg-border,rgba(0,0,0,0.08));
  border-radius:var(--pg-radius,10px); }
.os__head { display:flex; align-items:baseline; justify-content:space-between; }
.os__title { margin:0; font-size:1rem; font-weight:700; color:var(--pg-heading,var(--pg-text)); }
.os__count { font-size:0.82rem; color:var(--pg-text-secondary); }
.os__empty { padding:32px 18px; text-align:center;
  display:flex; flex-direction:column; align-items:center; gap:6px;
  color:var(--pg-text-secondary); }
.os__empty-icon { font-size:36px; opacity:0.5; }
.os__empty-title { font-weight:600; color:var(--pg-text); }
.os__empty-body { font-size:0.88rem; }
.os__list { list-style:none; margin:0; padding:0; display:flex; flex-direction:column; }
.os__row { display:grid; grid-template-columns:auto 1fr auto auto auto;
  align-items:center; gap:12px; padding:12px 0;
  border-bottom:1px solid var(--pg-border,rgba(0,0,0,0.06)); }
.os__row:last-child { border-bottom:none; }
.os__actions { display:flex; align-items:center; gap:4px; }
.os__edit { font-size:0.78rem; font-weight:600; padding:4px 10px;
  border-radius:999px; border:1px solid var(--pg-border,rgba(0,0,0,0.12));
  background:transparent; color:var(--pg-text); cursor:pointer;
  transition:background 0.12s, color 0.12s, border-color 0.12s; font-family:inherit; }
.os__edit:hover, .os__edit.is-active { background:var(--pg-primary,#0070f3);
  color:var(--pg-on-primary,#fff); border-color:transparent; }
.os__thumb { width:56px; height:56px; border-radius:8px; object-fit:cover;
  background:var(--pg-surface-alt,rgba(0,0,0,0.03)); }
.os__thumb--placeholder { display:flex; align-items:center; justify-content:center;
  font-weight:700; color:var(--pg-text-secondary); font-size:0.75rem; }
.os__rowmeta { min-width:0; }
.os__name { font-weight:600; font-size:0.92rem; color:var(--pg-text); }
.os__sep { margin:0 6px; color:var(--pg-text-secondary); font-weight:400; }
.os__style { color:var(--pg-text-secondary); font-weight:500; }
.os__detail { font-size:0.78rem; color:var(--pg-text-secondary);
  margin-top:3px; line-height:1.45;
  overflow:hidden; text-overflow:ellipsis;
  display:-webkit-box; -webkit-line-clamp:2; line-clamp:2; -webkit-box-orient:vertical; }
.os__qty { display:flex; align-items:center; gap:6px; padding:4px 6px;
  background:var(--pg-surface-alt,rgba(0,0,0,0.03)); border-radius:999px; }
.os__qbtn { width:24px; height:24px; border-radius:50%;
  border:none; cursor:pointer; font-size:14px; line-height:1;
  background:var(--pg-surface,#fff); color:var(--pg-text);
  box-shadow:0 1px 2px rgba(0,0,0,0.06); font-family:inherit; }
.os__qbtn:hover:not([disabled]) { background:var(--pg-primary,#0070f3); color:var(--pg-on-primary,#fff); }
.os__qbtn[disabled] { opacity:0.4; cursor:not-allowed; }
.os__qval { min-width:18px; text-align:center; font-weight:600; font-size:0.88rem; }
.os__line { display:flex; flex-direction:column; align-items:flex-end; gap:2px; min-width:90px; }
.os__lineprice { font-size:0.78rem; color:var(--pg-text-secondary); }
.os__linetotal { font-weight:700; font-size:0.95rem; color:var(--pg-text); }
.os__remove { width:28px; height:28px; border-radius:50%;
  border:none; background:transparent; color:var(--pg-text-secondary);
  cursor:pointer; font-size:18px; line-height:1; font-family:inherit; }
.os__remove:hover { background:var(--pg-error-bg,rgba(239,68,68,0.08)); color:var(--pg-error,#dc2626); }
.os__foot { margin-top:4px; display:flex; flex-direction:column; gap:6px;
  padding-top:10px; border-top:1px solid var(--pg-border,rgba(0,0,0,0.08)); }
.os__line-row { display:flex; justify-content:space-between;
  font-size:0.85rem; color:var(--pg-text-secondary); }
.os__total-row { display:flex; justify-content:space-between; font-size:1rem; padding-top:4px; }
.os__total-row strong { font-size:1.1rem; color:var(--pg-text); }

/* ── order-submit (separate namespace so it doesn't clash with summary above) ── */
.osub { display:flex; flex-direction:column; gap:10px; padding:14px 18px;
  background:var(--pg-surface,#fff); border:1px solid var(--pg-border,rgba(0,0,0,0.08));
  border-radius:var(--pg-radius,10px); }
.osub--success { align-items:center; text-align:center; padding:28px 24px;
  background:var(--pg-success-bg,rgba(34,197,94,0.08)); border-color:var(--pg-success,#22c55e); }
.osub__icon { width:56px; height:56px; border-radius:50%;
  display:flex; align-items:center; justify-content:center;
  background:var(--pg-success,#22c55e); color:#fff;
  font-size:28px; font-weight:700; }
.osub__title { margin:0; font-size:1.1rem; font-weight:700; color:var(--pg-success,#16a34a); }
.osub__body { margin:0; font-size:0.9rem; color:var(--pg-text); }
.osub__row { display:flex; align-items:center; justify-content:space-between; gap:12px; }
.osub__summary { display:flex; flex-direction:column; gap:2px; min-width:0; }
.osub__items { font-size:0.92rem; font-weight:600; color:var(--pg-text); }
.osub__total { font-size:0.85rem; color:var(--pg-text-secondary); }
.osub__btn { padding:11px 22px; font-size:0.95rem; font-weight:600;
  border-radius:8px; cursor:pointer; border:1px solid transparent; font-family:inherit; }
.osub__btn[disabled] { opacity:0.5; cursor:not-allowed; }
.osub__btn--primary { background:var(--pg-primary,#0070f3); color:var(--pg-on-primary,#fff); }
.osub__btn--primary:hover:not([disabled]) { filter:brightness(1.05); }
.osub__btn--ghost { background:transparent; color:var(--pg-success,#16a34a);
  border-color:var(--pg-success,#22c55e); }
.osub__hint { font-size:0.82rem; color:var(--pg-text-secondary); padding:4px 2px; }
.osub__error { font-size:0.88rem; color:var(--pg-error,#dc2626);
  background:var(--pg-error-bg,rgba(239,68,68,0.08));
  padding:8px 10px; border-radius:6px; }

/* ── product-selection ──────────────────────────────────── */
.ps { display:flex; flex-direction:column; gap:14px; padding:18px;
  background:var(--pg-surface,#fff); border:1px solid var(--pg-border,rgba(0,0,0,0.08));
  border-radius:var(--pg-radius,10px); }
.ps__gate { padding:36px 18px; text-align:center;
  display:flex; flex-direction:column; align-items:center; gap:8px;
  color:var(--pg-text-secondary); }
.ps__gate-icon { font-size:28px; opacity:0.6; }
.ps__gate-title { font-weight:700; color:var(--pg-text); }
.ps__gate-body { font-size:0.88rem; }
.ps__head { display:flex; align-items:center; justify-content:space-between;
  gap:12px; flex-wrap:wrap; }
.ps__steps { list-style:none; margin:0; padding:0;
  display:flex; align-items:center; gap:18px; }
.ps__step { display:flex; align-items:center; gap:8px;
  font-size:0.82rem; color:var(--pg-text-secondary); position:relative; }
.ps__step + .ps__step::before { content:''; position:absolute; left:-14px; top:50%;
  width:8px; height:1px; background:var(--pg-border); }
.ps__num { width:22px; height:22px; border-radius:50%;
  display:inline-flex; align-items:center; justify-content:center;
  font-size:11px; font-weight:700;
  background:var(--pg-surface-alt,rgba(0,0,0,0.05)); color:var(--pg-text-secondary); }
.ps__step.is-active .ps__num { background:var(--pg-primary,#0070f3); color:var(--pg-on-primary,#fff); }
.ps__step.is-active .ps__lbl { color:var(--pg-text); font-weight:600; }
.ps__step.is-done .ps__num { background:var(--pg-success,#22c55e); color:#fff; }
.ps__catalogue { padding:8px 14px; font-size:0.82rem; font-weight:600;
  background:transparent; color:var(--pg-primary,#0070f3);
  border:1px solid var(--pg-primary,#0070f3); border-radius:7px;
  cursor:pointer; font-family:inherit; }
.ps__catalogue:hover { background:rgba(0,112,243,0.08); }
.ps__crumbs { display:flex; align-items:center; gap:6px; font-size:0.85rem; }
.ps__crumb { background:transparent; border:none; padding:2px 4px; cursor:pointer;
  color:var(--pg-primary,#0070f3); font:inherit; }
.ps__crumb[disabled] { color:var(--pg-text); cursor:default; font-weight:600; }
.ps__crumb-sep { color:var(--pg-text-secondary); }
.ps__hint, .ps__error { font-size:0.88rem; color:var(--pg-text-secondary); padding:12px 4px; }
.ps__error { color:var(--pg-error,#dc2626); }
.ps__grid { display:grid; gap:14px; }
.ps__grid--list { gap:10px; }
.ps__card { display:flex; flex-direction:column;
  background:var(--pg-surface-alt,rgba(0,0,0,0.02));
  border:1px solid transparent; border-radius:10px;
  cursor:pointer; padding:0; text-align:left;
  overflow:hidden; transition:transform 0.12s ease, border-color 0.12s ease, box-shadow 0.12s ease;
  font-family:inherit; }
.ps__card:hover { transform:translateY(-1px);
  border-color:var(--pg-primary,#0070f3);
  box-shadow:0 4px 12px rgba(0,0,0,0.06); }
.ps__cardimg { aspect-ratio:4 / 3; background-size:cover; background-position:center;
  background-color:var(--pg-surface,#fff); }
.ps__cardbody { padding:10px 12px; display:flex; flex-direction:column; gap:3px; }
.ps__cardname { font-weight:600; font-size:0.92rem; color:var(--pg-text); }
.ps__cardprice { font-size:0.85rem; color:var(--pg-text-secondary); font-weight:500; }
.ps__cardmeta { font-size:0.78rem; color:var(--pg-text-secondary); }
.ps__card--style .ps__cardimg { aspect-ratio:1 / 1; }
.ps__delta { font-size:0.78rem; color:var(--pg-text-secondary); font-weight:500; }
.ps__delta.is-up { color:var(--pg-warning,#d97706); }
.ps__customize { display:flex; flex-direction:column; gap:16px; }
.ps__section { display:flex; flex-direction:column; gap:10px; padding:14px;
  background:var(--pg-surface-alt,rgba(0,0,0,0.02)); border-radius:8px; }
.ps__sectitle { margin:0; font-size:0.85rem; font-weight:700; text-transform:uppercase;
  letter-spacing:0.05em; color:var(--pg-text-secondary); }
.ps__unit { text-transform:none; font-weight:500; }
.ps__fields { display:grid;
  grid-template-columns:repeat(auto-fit, minmax(180px, 1fr)); gap:12px; }
.ps__field { display:flex; flex-direction:column; gap:6px; }
.ps__field--full { grid-column:1 / -1; }
.ps__field--invalid .ps__input,
.ps__field--invalid .ps__pill,
.ps__field--invalid .ps__swatch { border-color:var(--pg-error,#dc2626); }
.ps__fieldlabel { font-size:0.78rem; font-weight:600; color:var(--pg-text); }
.ps__req { color:var(--pg-error,#dc2626); margin-left:2px; }
.ps__fieldhint { font-size:11px; color:var(--pg-text-secondary); }
.ps__fielderr { font-size:11px; color:var(--pg-error,#dc2626); }
.ps__input { padding:8px 10px; font-size:0.88rem;
  background:var(--pg-bg,#fff); border:1px solid var(--pg-border,rgba(0,0,0,0.12));
  border-radius:6px; color:var(--pg-text); outline:none; font-family:inherit; }
.ps__input:focus { border-color:var(--pg-primary,#0070f3); }
.ps__input--price { max-width:140px; }
.ps__swatches { display:flex; gap:6px; flex-wrap:wrap; }
.ps__swatch { width:26px; height:26px; border-radius:50%;
  border:2px solid var(--pg-border,rgba(0,0,0,0.15));
  cursor:pointer; padding:0; }
.ps__swatch.is-active { border-color:var(--pg-primary,#0070f3);
  box-shadow:0 0 0 2px var(--pg-surface,#fff), 0 0 0 4px var(--pg-primary,#0070f3); }
.ps__pills, .ps__radios { display:flex; flex-wrap:wrap; gap:6px; }
.ps__pill { padding:6px 12px; font-size:0.82rem;
  background:var(--pg-bg,#fff); border:1px solid var(--pg-border,rgba(0,0,0,0.15));
  border-radius:999px; color:var(--pg-text); cursor:pointer; font-family:inherit; }
.ps__pill:hover { border-color:var(--pg-primary,#0070f3); }
.ps__pill.is-active { background:var(--pg-primary,#0070f3); color:var(--pg-on-primary,#fff);
  border-color:var(--pg-primary,#0070f3); }
.ps__imgpills { display:grid; grid-template-columns:repeat(auto-fill, minmax(72px, 1fr)); gap:8px; }
.ps__imgpill { display:flex; flex-direction:column; align-items:center; gap:6px;
  padding:6px; background:var(--pg-bg,#fff);
  border:2px solid var(--pg-border,rgba(0,0,0,0.12)); border-radius:10px;
  cursor:pointer; font-family:inherit;
  transition:border-color 0.12s, transform 0.12s, box-shadow 0.12s; }
.ps__imgpill:hover { border-color:var(--pg-primary,#0070f3); transform:translateY(-1px); }
.ps__imgpill.is-active { border-color:var(--pg-primary,#0070f3);
  box-shadow:0 0 0 3px rgba(0,112,243,0.15); }
.ps__imgpill-thumb { display:block; width:100%; aspect-ratio:1 / 1;
  border-radius:6px; background-size:cover; background-position:center;
  background-color:var(--pg-surface-alt,rgba(0,0,0,0.04)); }
.ps__imgpill-thumb--blank { background:var(--pg-surface-alt,rgba(0,0,0,0.04)); }
.ps__imgpill-label { font-size:0.75rem; color:var(--pg-text); line-height:1.2; text-align:center; }
.ps__imgpill.is-active .ps__imgpill-label { font-weight:600; }
.ps__radio { display:inline-flex; align-items:center; gap:6px; font-size:0.85rem; }
.ps__toggle { display:inline-flex; align-items:center; gap:6px; font-size:0.85rem; }
.ps__group { display:flex; flex-direction:column; gap:8px; }
.ps__grouplabel { font-size:0.78rem; font-weight:600; color:var(--pg-text-secondary); }
.ps__measgrid { display:grid; grid-template-columns:repeat(auto-fit, minmax(120px, 1fr)); gap:10px; }
.ps__measinput { position:relative; display:flex; align-items:center; }
.ps__measinput .ps__input { padding-right:32px; width:100%; }
.ps__measunit { position:absolute; right:10px; font-size:0.78rem;
  color:var(--pg-text-secondary); pointer-events:none; }
.ps__section--qty { display:flex; flex-direction:column; gap:8px; }
.ps__qtyrow { display:flex; align-items:center; justify-content:space-between; gap:12px; }
.ps__qtyrow--total { padding-top:8px;
  border-top:1px solid var(--pg-border,rgba(0,0,0,0.08)); font-size:1rem; }
.ps__qty { display:flex; align-items:center; gap:6px; padding:4px 6px;
  background:var(--pg-surface,#fff); border-radius:999px;
  border:1px solid var(--pg-border); }
.ps__qbtn { width:26px; height:26px; border-radius:50%;
  border:none; cursor:pointer; font-size:14px; line-height:1;
  background:transparent; color:var(--pg-text); font-family:inherit; }
.ps__qbtn:hover:not([disabled]) { background:var(--pg-surface-alt,rgba(0,0,0,0.05)); }
.ps__qbtn[disabled] { opacity:0.4; cursor:not-allowed; }
.ps__qval { min-width:22px; text-align:center; font-weight:600; font-size:0.92rem; }
.ps__priceval { font-weight:600; }
.ps__validmsg { display:flex; align-items:center; gap:8px; padding:10px 14px;
  background:var(--pg-error-bg,rgba(239,68,68,0.08));
  color:var(--pg-error,#dc2626); border:1px solid var(--pg-error,#dc2626);
  border-radius:8px; font-size:0.88rem; font-weight:500; }
.ps__validicon { font-size:16px; }
.ps__actions { display:flex; justify-content:space-between; gap:8px; padding-top:4px; }
.ps__btn { padding:11px 22px; font-size:0.92rem; font-weight:600;
  border-radius:8px; cursor:pointer; border:1px solid transparent; font-family:inherit; }
.ps__btn--primary { background:var(--pg-primary,#0070f3); color:var(--pg-on-primary,#fff); }
.ps__btn--primary:hover { filter:brightness(1.05); }
.ps__btn--ghost { background:transparent; color:var(--pg-text); border-color:var(--pg-border); }
.ps__cataloguecta { display:flex; flex-direction:column; align-items:center;
  gap:10px; padding:36px 24px; text-align:center;
  background:linear-gradient(180deg, var(--pg-surface,#fff) 0%, var(--pg-surface-alt,rgba(0,0,0,0.03)) 100%);
  border-radius:10px; }
.ps__cataloguecta-icon { font-size:32px; opacity:0.85; }
.ps__cataloguecta-title { font-weight:700; font-size:1.05rem; color:var(--pg-text); }
.ps__cataloguecta-body { font-size:0.9rem; max-width:420px; line-height:1.5;
  color:var(--pg-text-secondary); margin-bottom:4px; }
.ps__customize-wrap { display:flex; flex-direction:column; gap:16px; }
.ps__customize-wrap--split { display:grid;
  grid-template-columns:minmax(0, 1.15fr) minmax(0, 1fr); gap:20px; align-items:start; }
.ps__previewpanel { position:sticky; top:12px; min-width:0; }
@media (max-width:920px) {
  .ps__customize-wrap--split { grid-template-columns:1fr; }
  .ps__previewpanel { position:static; }
}

/* ── product-preview ───────────────────────────────────── */
.pp { display:flex; flex-direction:column; gap:12px; padding:16px;
  background:var(--pg-surface,#fff); border:1px solid var(--pg-border,rgba(0,0,0,0.08));
  border-radius:var(--pg-radius,10px); }
.pp--inline { padding:10px; gap:8px; }
.pp--large { padding:24px; gap:16px; }
.pp__empty { padding:36px 18px; text-align:center;
  display:flex; flex-direction:column; align-items:center; gap:8px;
  color:var(--pg-text-secondary); }
.pp__empty-icon { font-size:32px; opacity:0.5; }
.pp__empty-title { font-weight:700; color:var(--pg-text); font-size:0.95rem; }
.pp__empty-body { font-size:0.85rem; max-width:360px; line-height:1.5; }
.pp__stage { position:relative; width:100%; max-width:100%;
  border-radius:10px; overflow:hidden;
  background:var(--pg-surface-alt,rgba(0,0,0,0.03)); }
.pp__base { position:absolute; inset:0; width:100%; height:100%; object-fit:cover; }
.pp__base--contain { object-fit:contain; padding:12px; }
.pp__base--cover { object-fit:cover; }
.pp__base--placeholder { display:flex; align-items:center; justify-content:center;
  font-weight:700; font-size:2rem; color:var(--pg-text-secondary); }
.pp__stage--photo { background:linear-gradient(180deg, var(--pg-surface,#fff) 0%, var(--pg-surface-alt,rgba(0,0,0,0.04)) 100%); }
.pp__tabs { display:inline-flex; gap:2px; padding:3px;
  background:var(--pg-surface-alt,rgba(0,0,0,0.04));
  border-radius:10px; align-self:flex-start; }
.pp__tab { display:inline-flex; align-items:center; gap:6px;
  padding:8px 14px; font-size:0.85rem; font-weight:600;
  background:transparent; border:none; border-radius:7px;
  color:var(--pg-text-secondary,#64748b);
  cursor:pointer; font-family:inherit;
  transition:background 0.12s, color 0.12s; position:relative; }
.pp__tab:hover:not(.is-active) { color:var(--pg-text); }
.pp__tab.is-active { background:var(--pg-surface,#fff);
  color:var(--pg-text,#0f172a);
  box-shadow:0 1px 3px rgba(0,0,0,0.06); }
.pp__tab-dot { width:6px; height:6px; border-radius:50%;
  background:linear-gradient(120deg, #6d28d9, #2563eb); margin-left:2px; }
.pp__livebadge { position:absolute; top:10px; right:10px;
  display:inline-flex; align-items:center; gap:6px;
  padding:5px 10px; background:rgba(15,23,42,0.7); color:#fff;
  font-size:11px; font-weight:600;
  letter-spacing:0.04em; text-transform:uppercase;
  border-radius:999px; backdrop-filter:blur(4px); }
.pp__livebadge--sketch { background:rgba(15,23,42,0.6); }
.pp__livedot { width:8px; height:8px; border-radius:50%;
  background:#22c55e; box-shadow:0 0 8px rgba(34,197,94,0.7);
  animation:pp-pulse 1.6s ease-in-out infinite; }
@keyframes pp-pulse { 0%,100% { opacity:1; } 50% { opacity:0.55; } }
.pp__aibadge { position:absolute; top:10px; left:10px;
  display:inline-flex; align-items:center; gap:6px;
  padding:5px 12px; background:linear-gradient(120deg, #6d28d9 0%, #2563eb 100%);
  color:#fff; font-size:11px; font-weight:700;
  letter-spacing:0.05em; text-transform:uppercase; border-radius:999px; }
.pp__aiprompt { position:absolute; inset:0;
  display:flex; flex-direction:column; align-items:center; justify-content:center;
  gap:10px; padding:40px 30px; text-align:center;
  background:linear-gradient(135deg, rgba(109,40,217,0.06), rgba(37,99,235,0.06)); }
.pp__aipromptIcon { font-size:36px;
  background:linear-gradient(120deg, #6d28d9, #2563eb);
  -webkit-background-clip:text; -webkit-text-fill-color:transparent;
  background-clip:text; }
.pp__aipromptTitle { font-size:1rem; font-weight:700; color:var(--pg-text,#0f172a); }
.pp__aipromptBody { font-size:0.85rem; line-height:1.5;
  color:var(--pg-text-secondary,#64748b); max-width:320px; }
.pp__corner { position:absolute; bottom:10px; left:10px; right:10px;
  display:flex; flex-wrap:wrap; gap:6px;
  justify-content:flex-start; pointer-events:none; }
.pp__cornerchip { display:inline-flex; align-items:center; gap:6px;
  padding:4px 10px 4px 4px; background:rgba(255,255,255,0.92);
  backdrop-filter:blur(8px); border-radius:999px;
  box-shadow:0 2px 8px rgba(0,0,0,0.12); }
.pp__cornerthumb { width:22px; height:22px; border-radius:50%;
  background-size:cover; background-position:center;
  flex-shrink:0; border:1px solid rgba(0,0,0,0.06); }
.pp__cornerthumb--swatch { border:1px solid rgba(0,0,0,0.1); }
.pp__cornermeta { display:flex; flex-direction:column; line-height:1.1; }
.pp__cornerfield { font-size:9px; font-weight:700; letter-spacing:0.05em;
  color:#64748b; text-transform:uppercase; }
.pp__cornerlabel { font-size:11px; font-weight:600; color:#0f172a; }
.pp__btn { padding:10px 20px; font-size:0.92rem; font-weight:600;
  border:1px solid transparent; border-radius:8px;
  cursor:pointer; font-family:inherit; }
.pp__btn[disabled] { opacity:0.5; cursor:not-allowed; }
.pp__btn--primary { background:linear-gradient(120deg, #6d28d9 0%, #2563eb 100%); color:#fff; }
.pp__btn--primary:hover:not([disabled]) { filter:brightness(1.08); }
.pp__btn--ghost { background:transparent; color:var(--pg-text); border-color:var(--pg-border); }
.pp__btn--ghost:hover { background:var(--pg-surface-alt,rgba(0,0,0,0.04)); }
.pp__btn--link { background:transparent; padding:10px 6px;
  color:var(--pg-text-secondary); border-color:transparent;
  text-decoration:underline; font-weight:500; }
.pp__btn--link:hover { color:var(--pg-text); }
.pp__aitop { display:flex; flex-direction:column; gap:10px;
  padding:10px 12px;
  background:var(--pg-surface-alt,rgba(99,102,241,0.05));
  border:1px solid var(--pg-border,rgba(0,0,0,0.08));
  border-radius:10px; }
.pp__aitop-row { display:flex; align-items:center; gap:10px; flex-wrap:wrap; }
.pp__aierr { font-size:0.82rem; color:var(--pg-error,#dc2626); }
.pp__aierr--top { margin:0; }
.pp__details { display:flex; flex-direction:column; gap:12px;
  padding:12px; background:var(--pg-surface,#fff);
  border:1px solid var(--pg-border,rgba(0,0,0,0.08));
  border-radius:8px; }
.pp__details-row { display:flex; gap:12px; align-items:baseline; font-size:0.82rem; }
.pp__details-row--col { flex-direction:column; align-items:stretch; gap:6px; }
.pp__details-key { font-weight:600; color:var(--pg-text-secondary);
  text-transform:uppercase; letter-spacing:0.04em; font-size:0.7rem; }
.pp__details-prompt { margin:0; padding:10px 12px;
  background:var(--pg-surface-alt,rgba(0,0,0,0.04));
  border-radius:6px;
  font-family:ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size:0.78rem; line-height:1.5; color:var(--pg-text);
  white-space:pre-wrap; word-break:break-word;
  max-height:220px; overflow:auto; }
.pp__refgrid { display:grid;
  grid-template-columns:repeat(auto-fill, minmax(110px, 1fr)); gap:10px; }
.pp__refcard { margin:0; display:flex; flex-direction:column; gap:6px;
  padding:6px; background:var(--pg-surface-alt,rgba(0,0,0,0.03));
  border:1px solid var(--pg-border,rgba(0,0,0,0.06)); border-radius:6px; }
.pp__refthumb { width:100%; aspect-ratio:1; object-fit:cover;
  background:#fff; border-radius:4px; }
.pp__refcap { display:flex; align-items:center; gap:6px;
  font-size:0.72rem; color:var(--pg-text-secondary); line-height:1.3; }
.pp__refidx { flex:none; width:18px; height:18px;
  display:inline-flex; align-items:center; justify-content:center;
  border-radius:50%;
  background:linear-gradient(120deg, #6d28d9 0%, #2563eb 100%);
  color:#fff; font-weight:700; font-size:0.65rem; }
.pp__reflabel { flex:1; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.pp__refthumb--blank { display:flex; align-items:center; justify-content:center;
  color:var(--pg-text-secondary); font-weight:700; }
.pp__details-banner { padding:8px 10px; font-size:0.78rem;
  color:var(--pg-text-secondary);
  background:var(--pg-surface-alt,rgba(0,0,0,0.03));
  border-left:3px solid var(--pg-border,rgba(0,0,0,0.15));
  border-radius:4px; line-height:1.4; }
.pp__details-banner--live { color:#065f46; background:rgba(16,185,129,0.08);
  border-left-color:#10b981; }
.pp__details-empty { font-size:0.78rem; color:var(--pg-text-secondary); font-style:italic; }
.pp__refgrid--skipped { opacity:0.7; }
.pp__refcard--skipped { border-style:dashed; }
.pp__refreason { flex:none; font-size:0.66rem;
  color:var(--pg-text-secondary); font-style:italic; }
.pp__aidesc { margin:0; flex:1; font-size:0.85rem;
  color:var(--pg-text-secondary); line-height:1.4; }
.pp__tint { position:absolute; inset:0; pointer-events:none; }
.pp__loading { position:absolute; bottom:8px; right:12px;
  font-size:11px; color:#fff;
  background:rgba(0,0,0,0.5); padding:3px 8px; border-radius:999px; }
.pp__featurelabel { font-size:11px; font-weight:700;
  text-transform:uppercase; letter-spacing:0.06em;
  color:var(--pg-text-secondary,#666); margin-top:4px; }
.pp__featuregallery { display:grid;
  grid-template-columns:repeat(auto-fill, minmax(96px, 1fr)); gap:10px; }
.pp__featurecard { margin:0;
  display:flex; flex-direction:column; gap:6px;
  padding:8px; background:var(--pg-bg,#fafafa);
  border:1px solid var(--pg-border,rgba(0,0,0,0.08)); border-radius:10px; }
.pp__featurethumb { display:flex; align-items:center; justify-content:center;
  width:100%; aspect-ratio:1 / 1; border-radius:6px;
  background-size:cover; background-position:center;
  background-color:var(--pg-surface-alt,rgba(0,0,0,0.04));
  font-weight:700; color:var(--pg-text-secondary); }
.pp__featurethumb--swatch { border:1px solid rgba(0,0,0,0.08); }
.pp__featurethumb--blank { background:var(--pg-surface-alt,rgba(0,0,0,0.06)); }
.pp__featurecap { display:flex; flex-direction:column; gap:1px; }
.pp__featurefield { font-size:10px; font-weight:600;
  text-transform:uppercase; letter-spacing:0.05em;
  color:var(--pg-text-secondary); }
.pp__featurevalue { font-size:0.82rem; font-weight:600;
  color:var(--pg-text); line-height:1.2; }
.pp__measbadge { display:inline-flex; align-items:center; gap:6px;
  align-self:flex-start; padding:6px 12px; font-size:0.78rem;
  background:var(--pg-surface-alt,rgba(0,0,0,0.03));
  color:var(--pg-text-secondary); border-radius:999px; }
.pp__measicon { font-size:14px; }
.pp__caption { margin:0; font-size:0.92rem;
  color:var(--pg-text); line-height:1.5; font-weight:500; }
.pp__layouthint { padding:36px 18px; text-align:center;
  color:var(--pg-text-secondary); font-size:0.88rem;
  background:var(--pg-surface-alt,rgba(0,0,0,0.03));
  border-radius:10px; }

/* ── payment checkout (the application's OWN gateway) ───── */
.paychk { display:flex; flex-direction:column; gap:10px; padding:18px;
  background:var(--pg-surface,#fff); border:1px solid var(--pg-border,rgba(0,0,0,0.08));
  border-radius:var(--pg-radius,10px); }
.paychk__title { margin:0; font-size:1.05rem; font-weight:700; color:var(--pg-text); }
.paychk__muted { margin:0; font-size:0.88rem; color:var(--pg-text-secondary); }
.paychk__row { display:flex; align-items:center; gap:10px; flex-wrap:wrap; }
.paychk__btn { padding:11px 22px; font-size:0.95rem; font-weight:600;
  border-radius:8px; cursor:pointer; border:1px solid var(--pg-border,rgba(0,0,0,0.12));
  background:transparent; color:var(--pg-text); font-family:inherit; }
.paychk__btn[disabled] { opacity:0.5; cursor:not-allowed; }
.paychk__btn--primary { background:var(--pg-primary,#0070f3);
  color:var(--pg-on-primary,#fff); border-color:transparent; }
.paychk__btn--primary:hover:not([disabled]) { filter:brightness(1.05); }
.paychk__success { display:flex; flex-direction:column; gap:4px;
  padding:16px 18px; border-radius:10px;
  background:var(--pg-success-bg,rgba(34,197,94,0.08));
  border:1px solid var(--pg-success,#22c55e); }
.paychk__success strong { color:var(--pg-success,#16a34a); }
.paychk__error { font-size:0.88rem; color:var(--pg-error,#dc2626);
  background:var(--pg-error-bg,rgba(239,68,68,0.08));
  padding:8px 10px; border-radius:6px; }
/* Author-time notice: shown on the canvas while the block is unconfigured. */
.paychk__note { padding:14px 16px; font-size:0.88rem;
  color:var(--pg-text-secondary); border-radius:10px;
  border:1px dashed var(--pg-border,rgba(0,0,0,0.18));
  background:var(--pg-surface-alt,rgba(0,0,0,0.03)); }

/* ── product-catalogue modal (placeholder) ── */
.ecat-overlay { position:fixed; inset:0; z-index:1000;
  background:rgba(15,23,42,0.55); backdrop-filter:blur(2px);
  display:flex; align-items:center; justify-content:center; padding:36px; }
.ecat-modal { background:var(--pg-surface,#fff); border-radius:12px;
  max-width:980px; width:100%; max-height:90vh; overflow:auto;
  box-shadow:0 16px 56px rgba(0,0,0,0.25);
  display:flex; flex-direction:column; padding:24px; gap:16px; }
.ecat-modal__head { display:flex; align-items:center; justify-content:space-between; gap:12px; }
.ecat-modal__title { margin:0; font-size:1.05rem; font-weight:700; color:var(--pg-text); }
.ecat-modal__close { background:transparent; border:none; cursor:pointer;
  width:36px; height:36px; border-radius:50%;
  font-size:22px; line-height:1; color:var(--pg-text-secondary);
  font-family:inherit; }
.ecat-modal__close:hover { background:var(--pg-surface-alt,rgba(0,0,0,0.04)); }
`
